var _defs, _path, _path2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c001acedb1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.3125 0 L 236 0 L 236 375 L 25.3125 375 Z M 25.3125 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6bc3768b04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187 0 L 350.0625 0 L 350.0625 282 L 187 282 Z M 187 0 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9a8888",
    d: "M 299.855469 252.195312 L 299.855469 122.804688 L 187.671875 58.113281 L 187.671875 187.5 L 299.855469 252.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f5256",
    d: "M 75.488281 252.195312 L 187.671875 316.886719 L 299.855469 252.195312 L 187.671875 187.5 L 75.488281 252.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c001acedb1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c46dbd",
    d: "M 25.300781 93.863281 L 25.300781 281.136719 L 187.671875 374.777344 L 235.304688 344.019531 L 187.671875 316.886719 L 75.488281 252.195312 L 75.488281 122.804688 L 187.671875 58.113281 L 187.671875 0.222656 L 25.300781 93.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6bc3768b04)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d38acb",
    d: "M 187.671875 0.222656 L 187.671875 58.113281 L 299.855469 122.804688 L 299.855469 252.195312 L 350.042969 281.136719 L 350.042969 93.863281 L 187.671875 0.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogos);
export default __webpack_public_path__ + "static/media/logos.fdfdada7c6ce6db7c2338dc3250fc1a2.svg";
export { ForwardRef as ReactComponent };